import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { splitNumber } from "../../../utils/utility";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Sector,
} from "recharts";
import map from "lodash/map";
import reduce from "lodash/reduce";
import sortBy from "lodash/sortBy";
const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        className="recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15"
        style={{ background: "#000", border: "solid 1px #000", color: "#FFF" }}
      >
        <p className="recharts-tooltip-label no-margin" />
        <ul className="recharts-tooltip-item-list no-padding no-margin">
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "25px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
              }}
            >
              <div className="recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5">
                {payload[0].payload.key +
                  " : " +
                  payload[0].payload.percentage +
                  "%"}
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }

  return null;
};

class PieChartHighlight extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
    };
  }

  isEmpty(data) {
    if (!data || data.length === 0) return true;
    for (var i = 0; i < data.length; i++) {
      if (data[i].value > 0) return false;
    }
    return true;
  }

  render() {
    const {
      showHighlight,
      showHeader,
      data,
      title,
      showDetail,
      showList,
      showPercentage,
    } = this.props;
    const sum = reduce(
      data,
      function(sum, d) {
        return sum + d.value;
      },
      0,
    );
    const processData = [];
    map(data, d => {
      processData.push({
        key: d.key,
        _key: d._key,
        middleVal: d.middleVal,
        value: d.value,
        percentage:
          sum <= 0 ? 0 : parseFloat(((d.value / sum) * 100).toFixed(2)),
      });
    });
    const sortData = sortBy(processData, "percentage").reverse();
    const COLORS = [
      "#216E69",
      "#32A59D",
      "#56CBC4",
      "#99DFDD",
      "#BBEAE7",
      "#BAE6FE",
      "#FFE0CA",
      "#F3D6D4",
    ];
    return (
      <div>
        <div>
          {title && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "24px",
                padding: "20px",
              }}
            >
              {title}
            </div>
          )}
        </div>
        {!this.isEmpty(sortData) ? (
          <div style={{ width: "100%", fontSize: "16px" }}>
            <div style={{ display: "flex" }}>
              {showHighlight === true && (
                <div
                  style={{
                    flex: "0 0 160px",
                    paddingLeft: "20px",
                    paddingTop: "50px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "70px",
                      color: COLORS[0],
                      fontWeight: "bold",
                      height: "71px",
                    }}
                  >
                    {sortData.length > 0 && sortData[0].percentage
                      ? parseInt(sortData[0].percentage, 10) + "%"
                      : ""}
                  </div>
                  <div
                    style={{
                      fontSize: "40px",
                      width: "150px",
                    }}
                  >
                    {sortData && sortData[0]
                      ? showList === true
                        ? sortData[0].key
                        : sortData[0].key.split(" ")[0]
                      : ""}
                  </div>
                </div>
              )}
              <div style={{ flex: "1 1 230px" }} className="_pie-chart">
                <ResponsiveContainer
                  width="100%"
                  height="100%"
                  minWidth="230px"
                  minHeight={showHighlight ? "320px" : "230px"}
                >
                  <PieChart>
                    <Pie
                      dataKey={"value"}
                      data={sortData}
                      onMouseEnter={(data, index) => {
                        this.setState({ activeIndex: index });
                      }}
                      onMouseLeave={() => {
                        this.setState({ activeIndex: -1 });
                      }}
                    >
                      {sortData.map((entry, idx) => (
                        <Cell
                          key={
                            "segment-highlight-chart" +
                            idx +
                            "-cell-" +
                            entry.key
                          }
                          fill={COLORS[idx % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                    {showList === false && (
                      <Legend
                        verticalAlign="top"
                        align="left"
                        formatter={(value, entry, index) => {
                          if (
                            entry &&
                            entry.payload &&
                            entry.payload.payload &&
                            entry.payload.payload.payload
                          )
                            return entry.payload.payload.payload.key;
                          else return "";
                        }}
                      />
                    )}
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
            {showList === true && (
              <div className="mt-20 mb-20">
                {showDetail && showHeader && (
                  <div
                    style={{
                      padding: "10px 20px",
                      margin: "-20px 20px -5px",
                      background: "#F5F5F5",
                      fontWeight: "bold",
                    }}
                  >
                    {showDetail && showHeader && (
                      <div>
                        {!this.props.middleKey ? (
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "1 1 50%" }}>
                              {this.props.stateName || "State"}
                            </div>
                            <div
                              style={{ flex: "1 1 50%", textAlign: "right" }}
                            >
                              {this.props.fieldTitle}
                            </div>
                          </div>
                        ) : (
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "1 1 20%" }}>
                              {this.props.stateName || "State"}
                            </div>
                            <div style={{ flex: "1 1 50%" }}>
                              {this.props.middleKey}
                            </div>
                            <div
                              style={{ flex: "1 1 30%", textAlign: "right" }}
                            >
                              {this.props.fieldTitle}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
                <div
                  style={{
                    padding: "0",
                    margin: "0px 20px",
                    height: "5px",
                    borderBottom: "solid 1px #EEEFF2 ",
                  }}
                >
                  &nbsp;
                </div>
                {sortData.map((entry, idx) => {
                  return (
                    <div
                      key={"sortdata-" + idx}
                      style={{
                        display: "flex",
                        padding: showDetail === true ? "10px 20px" : "10px 0",
                        margin: "0px 20px",
                        borderBottom: "solid 1px #EEEFF2 ",
                      }}
                    >
                      <div
                        style={{
                          width: entry.middleVal ? "20%" : "50%",
                          paddingLeft: "0px",
                        }}
                      >
                        {showDetail === false && (
                          <span
                            style={{
                              width: "18px",
                              height: "18px",
                              display: "inline-block",
                              marginRight: "10px",
                              background: COLORS[idx % COLORS.length],
                            }}
                          >
                            &nbsp;
                          </span>
                        )}
                        {entry._key || entry.key}
                      </div>
                      {entry.middleVal ? (
                        <div style={{ width: "50%" }}>{entry.middleVal}</div>
                      ) : null}
                      <div
                        style={{
                          width: entry.middleVal ? "30%" : "50%",
                          textAlign: "right",
                        }}
                      >
                        {showDetail === true
                          ? showPercentage
                            ? entry.percentage <= 0
                              ? "0"
                              : entry.percentage + "%"
                            : entry.value
                          : ""}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        )}
      </div>
    );
  }
}

PieChartHighlight.defaultProps = {
  showList: true,
  showDetail: false,
  showHeader: true,
  showHighlight: false,
  fieldTitle: "Estimated Reach",
  showPercentage: true,
};
export default PieChartHighlight;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/PieChartHighlight.js